import { Button, useToast, Heading, Box, Input, Text, Divider } from '@chakra-ui/react';

import xhr from 'xhr';

import React from 'react';

import InteractionsEditor from './interactiveVideo/InteractionsEditor';
import {
  SPEC_VERSION,
  validateInteractions,
  detectVideoDuration,
} from './interactiveVideo/interactionsSpec';

export default function UpdateInteractiveVideo(props) {
  const { setIsOpen2 } = props;

  const [inputText, setInputText] = React.useState('');
  const [textContent, setTextContent] = React.useState('');
  const [durationSeconds, setDurationSeconds] = React.useState(null);
  const [interactions, setInteractions] = React.useState([]);

  const toasts = useToast();

  const [loadingButton, setLoadingButton] = React.useState(false);

  React.useEffect(() => {
    setInputText(props.materialModal.video?.title || '');
    setTextContent(props.materialModal.video?.source || '');
    setDurationSeconds(props.materialModal.video?.duration_seconds || null);
    setInteractions(props.materialModal.video?.interactions?.interactions || []);
  }, [props.materialModal.id]);

  const handleSourceBlur = async () => {
    if (!textContent) return;
    const seconds = await detectVideoDuration(textContent);
    if (seconds) setDurationSeconds(seconds);
  };

  const handleUpdate = async () => {
    try {
      if (inputText === '') return alert('el titulo está vacio');
      if (textContent === '') return alert('el src está vacio');

      const validationError = validateInteractions(interactions);
      if (validationError) {
        return toasts({
          title: validationError,
          status: 'warning',
          duration: 4000,
          isClosable: true,
        });
      }

      setLoadingButton(true);

      let finalDuration = durationSeconds;
      if (!finalDuration) {
        finalDuration = await detectVideoDuration(textContent);
        if (finalDuration) setDurationSeconds(finalDuration);
      }

      const responseV = await xhr.put(`/videos/${props.materialModal.video.id}`, {
        data: {
          title: inputText,
          source: textContent,
          duration_seconds: finalDuration,
          interactions: {
            specVersion: SPEC_VERSION,
            interactions: [...interactions].sort((a, b) => a.anchorMs - b.anchorMs),
          },
        },
      });

      const responseMaterials = await xhr.put(`/materials/${props.materialModal.id}`, {
        data: {
          title: inputText,
        },
      });

      props.updateMaterials({ ...responseMaterials.data.data, video: { ...responseV.data.data } });

      toasts({
        title: 'El video interactivo se actualizó correctamente!',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      setIsOpen2(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingButton(false);
    }
  };

  return (
    <Box>
      <Box marginBottom="20px" position="relative" top="-10px">
        <Heading use="h3" width="100%">
          Vídeo interactivo
        </Heading>
      </Box>
      <Box>Titulo</Box>
      <Input value={inputText} onChange={(e) => setInputText(e.target.value)} />
      <br />
      <br />
      <Box>Source</Box>
      <Input value={textContent} onChange={(e) => setTextContent(e.target.value)} onBlur={handleSourceBlur} />
      {durationSeconds && (
        <Text marginTop="8px" fontSize="14px" color="#727d90">
          Duración: {Math.floor(durationSeconds / 60)}m {durationSeconds % 60}s
        </Text>
      )}

      <Divider marginY="20px" />

      <Heading as="h4" fontSize="18px" marginBottom="10px">
        Interacciones
      </Heading>
      <InteractionsEditor source={textContent} interactions={interactions} setInteractions={setInteractions} />

      <Button
        type="submit"
        colorScheme="#574feb"
        bg="#574feb"
        marginY="20px"
        width="140px"
        onClick={handleUpdate}
        isLoading={loadingButton}
      >
        Actualizar
      </Button>
    </Box>
  );
}
